import { Link } from 'react-router-dom';

const categories = [
  {
    id: 'tailgate',
    title: 'Tailgate Collection',
    subtitle: 'Pre-game essentials',
    badge: 'Fan Favorite',
    image: 'https://public.readdy.ai/ai/img_res/8e6cf6ee5a0d6d8d97548be68af839c3.jpg',
    cta: 'Shop Tailgate',
    accent: 'bg-[#6B0000]',
  },
  {
    id: 'student-spirit',
    title: 'Student Spirit',
    subtitle: 'Rep the Bulldogs on campus',
    badge: 'Campus Ready',
    image: 'https://readdy.ai/api/search-image?query=college%20students%20wearing%20maroon%20Mississippi%20State%20Bulldogs%20t-shirts%20on%20a%20university%20campus%20quad%2C%20backpacks%2C%20sunny%20day%2C%20energetic%20youthful%20atmosphere%2C%20lifestyle%20photography%20with%20brick%20buildings%20and%20trees%20in%20background%2C%20vibrant%20colors&width=700&height=900&seq=cat_student01&orientation=portrait',
    cta: 'Shop Student',
    accent: 'bg-gray-800',
  },
  {
    id: 'custom-name',
    title: 'Custom Name Shirts',
    subtitle: 'Your name. Your number.',
    badge: 'Personalized',
    image: 'https://readdy.ai/api/search-image?query=personalized%20maroon%20college%20football%20jersey%20style%20t-shirt%20with%20custom%20name%20and%20number%20displayed%20on%20clean%20white%20background%2C%20premium%20apparel%20product%20photography%2C%20sharp%20details%2C%20studio%20lighting%2C%20high%20resolution%20mockup&width=700&height=900&seq=cat_custom01&orientation=portrait',
    cta: 'Design Yours',
    accent: 'bg-[#6B0000]',
  },
];

export function GameDayCategories() {
  return (
    <section className="py-24 px-6 bg-[#f9f7f5]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-red-50 text-[#6B0000] text-xs font-bold uppercase tracking-widest rounded-full mb-4">
            Game Day Categories
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
            Find Your Game Day Look
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">
            From the tailgate to the student section — we've got the perfect Bulldogs shirt for every fan.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {categories.map((cat) => (
            <div
              key={cat.id}
              className="group relative overflow-hidden rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer"
            >
              <div className="w-full h-[480px]">
                <img
                  src={cat.image}
                  alt={cat.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>

              <div className="absolute top-4 left-4">
                <span className={`px-3 py-1 ${cat.accent} text-white text-xs font-bold rounded-full`}>
                  {cat.badge}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="text-white/70 text-xs font-semibold uppercase tracking-widest mb-1">{cat.subtitle}</p>
                <h3 className="text-2xl font-black text-white mb-4">{cat.title}</h3>
                <Link
                  to="/customize"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-white text-gray-900 text-sm font-bold rounded-lg hover:bg-red-50 hover:text-[#6B0000] transition-colors whitespace-nowrap"
                >
                  {cat.cta}
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
